import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import RemoteDataTable from '@components/remote-data-table/RemoteDataTable';
import { useFileUploadStatus } from './useFileUploadStatusData';
import styles from './FileUploadStatus.module.css';
import { LeftOutlined } from '@ant-design/icons';
import { NSPButton } from '@components/ui/NSPButton';
import { toTestAttrValue } from '@utils/testAttr';

const FileUploadStatus = () => {
  const { id: fileIngestionId } = useParams();
  const navigate = useNavigate();
  // Create a wrapper function that RemoteDataTable can call
  const useFileUploadStatusData = () => useFileUploadStatus(fileIngestionId);

  // Get filename for header (separate from RemoteDataTable)
  const { data } = useFileUploadStatus(fileIngestionId);
  const filename = data[0]?.filename || 'Unknown File';

  return (
    <div
      className={styles.container}
    >
      <div className={styles.headerCard}>
        <div className={styles.headerTitle}>
          <NSPButton
            onClick={() => navigate('/file-upload-logs')}
            icon={<LeftOutlined style={{ width: '14px', height: '14px' }} />}
            data-testid="back-button"
          >
            Back
          </NSPButton>
          <span data-testid="page-title" data-file-name={filename}>File Upload Status: {filename}</span>
        </div>
      </div>

      <RemoteDataTable
        useData={useFileUploadStatusData} // Pass the function, not the data
        rowKey="id" // Changed from "id" since your data doesn't have "id"
        testId="file-upload-status-table"
        cellTestId="job-value"
        rowTestAttrs={(record) => ({
          'data-testid': 'job-row',
          'data-parent-job': record.parentJobName ?? '',
          'data-sub-task': record.subTaskName ?? '',
          'data-level': toTestAttrValue(record.level),
          'data-status': toTestAttrValue(record.status),
        })}
        columnStructures={{
          parentJobName: {
            title: 'Parent Job Name',
            width: 200,
          },
          subTaskName: {
            title: 'Sub Task Name',
            width: 200,
            render: (text) => text || '-',
          },
          startTimeFormatted: {
            title: 'Start Time',
            width: 180,
          },
          endTimeFormatted: {
            title: 'End Time',
            width: 180,
            render: (text) => text || '-',
          },
          durationFormatted: {
            title: 'Duration',
            width: 100,
            render: (text) => text || '-',
          },
          level: {
            title: 'Level',
            width: 140,
            render: (text) => text || '-',
          },
          status: {
            title: 'Status',
            width: 120,
            render: (status) => <span className={`status-${status}`} data-testid="job-status" data-status={toTestAttrValue(status)}>{status}</span>,
          },
        }}
        columnsToIgnore={[
          'fileIngestionId',
          'startTime',
          'endTime',
          'duration',
          'filename',
          'runId',
          'id',
        ]}
      />
    </div>
  );
};

export default FileUploadStatus;
